import controllers from "venuescanner-js/services/controllers";

const fetchTemplates = async () => {
  const { data, errors, status } =
    await controllers.inboxTemplateService.templates.get();
  if (!status) {
    throw new Error(errors);
  }
  return Array.from(data.templates);
};

const createTemplate = async (template) => {
  try {
    await controllers.inboxTemplateService.templates.post(template);
  } catch (error) {
    // TODO: this would be nicer in the controllers method, but no unified server side api yet
    if (error.response.data.errors.message) {
      throw new Error(error.response.data.errors.message);
    }
    throw error;
  }
};

const updateTemplate = async (template) => {
  await controllers.inboxTemplateService.templates.post(template);
};

const deleteTemplate = async (template) => {
  await controllers.inboxTemplateService.templates.delete(template);
};
export default {
  fetchTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  fetch: fetchTemplates,
  create: createTemplate,
  update: updateTemplate,
  delete: deleteTemplate,
};
